module.exports = __webpack_public_path__ + "static/media/idea-factory-light.d2f4ad5c.svg";